import styled from 'styled-components';
import { fontSize } from 'styled-system';

/**
 * @typedef {import('styled-system').FontSizeProps} FontSizeProps
 */

const StyledHeader =
  /** @type {import('styled-components').ThemeStyledFunction<'h2', FontSizeProps>} */
  (styled.h2)`
  /* #46494c has no matching --dcm-* token default; locally-scoped var keeps
     light surfaces byte-identical while re-skinning under Concierge Mode. */
  --msh-heading-color: #46494c;
  .concierge-mode & {
    --msh-heading-color: var(--dcm-color-text-primary);
  }
  color: var(--msh-heading-color);
  font-size: 15px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: ${(props) => (props.mb ? props.mb : '21px')};
  text-transform: ${(props) => (props.lowercase ? 'none' : 'uppercase')};
  ${fontSize};
`;

export default StyledHeader;
